// src/lib/preload-css-manager.js - COMPLETE VERSION WITH FAST ANIMATIONS

// IMMEDIATE CSS MODE DETECTION - Runs before anything else!
(function() {
  console.log('🚨 [PRELOAD] Script executing at:', new Date().toISOString());
  console.log('🚨 [PRELOAD] Document readyState:', document.readyState);
  console.log('🚨 [PRELOAD] Body exists?', !!document.body);
  console.log('🚨 [PRELOAD] Current URL:', window.location.pathname);
  
  const path = window.location.pathname;
  const clayRoutes = ['/', '/pricing', '/company', '/privacy-policy', '/terms-of-service'];
  const signupPaths = ['/signup', '/pending-approval'];
  
  const isClayRoute = clayRoutes.includes(path);
  const isSignupRoute = signupPaths.some(p => path.startsWith(p));
  
  // Apply the correct class IMMEDIATELY
  if (isSignupRoute) {
    if (document.documentElement) {
      document.documentElement.className = 'signup-mode';
      console.log('✅ Set HTML class');
    }
    if (document.body) {
      document.body.className = 'signup-mode';
      console.log('✅ Set body class');
    } else {
      console.log('❌ Body not available yet!');
      // Wait for body to be available
      const observer = new MutationObserver((mutations, obs) => {
        if (document.body) {
          document.body.className = 'signup-mode';
          console.log('✅ Set body class (delayed)');
          obs.disconnect();
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    document.documentElement.setAttribute('data-mode', 'signup');
    console.log('🚀 [IMMEDIATE] Set signup mode for:', path);
  } else if (isClayRoute) {
    if (document.documentElement) {
      document.documentElement.className = 'clay-mode';
      console.log('✅ Set HTML class to clay-mode');
    }
    if (document.body) {
      document.body.className = 'clay-mode';
      console.log('✅ Set body class to clay-mode');
    } else {
      console.log('❌ Body not available yet for clay mode!');
      // Wait for body to be available
      const observer = new MutationObserver((mutations, obs) => {
        if (document.body) {
          document.body.className = 'clay-mode';
          console.log('✅ Set body class to clay-mode (delayed)');
          obs.disconnect();
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    document.documentElement.setAttribute('data-mode', 'clay');
    console.log('🚀 [IMMEDIATE] Set clay mode for:', path);
  }
  
  // Store for React
  window.__INITIAL_CSS_MODE__ = isSignupRoute ? 'signup' : (isClayRoute ? 'clay' : 'signup');
  console.log('🚨 [PRELOAD] Initial CSS mode stored:', window.__INITIAL_CSS_MODE__);
})();

class PreloadCSSManager {
  constructor() {
    this.isTransitioning = false;
    this.init();
  }

  init() {
    this.checkAndDisableClayCSS();
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.checkAndDisableClayCSS();
      });
    }
    
    this.watchForNewStyles();
    this.setupAnimationStyles();
  }

  setupAnimationStyles() {
    // Inject all animation styles
    const style = document.createElement('style');
    style.id = 'css-transition-animations';
    style.textContent = `
      /* Base overlay styles */
      .css-transition-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999999;
        pointer-events: none;
        opacity: 0;
      }

      /* Brown blob wipe - CSS switches at 50% (400ms) */
      .css-transition-overlay.wipe {
        background: #34261E;
        clip-path: circle(0% at 50% 50%);
        animation: wipeExpand 0.8s ease-out forwards;
      }

      @keyframes wipeExpand {
        0% { 
          clip-path: circle(0% at 50% 50%); 
          opacity: 1; 
        }
        50% { 
          clip-path: circle(100% at 50% 50%); 
          opacity: 1; 
        } /* CSS switches at this point */
        100% { 
          clip-path: circle(100% at 50% 50%); 
          opacity: 0; 
        }
      }

      /* Fast slide - CSS switches at 50% (200ms) */
      .css-transition-overlay.slide {
        background: linear-gradient(45deg, #34261E, #fef6ef);
        transform: translateX(-100%);
        animation: slideIn 0.4s ease-out forwards;
      }

      @keyframes slideIn {
        0% { transform: translateX(-100%); opacity: 1; }
        50% { transform: translateX(0); opacity: 1; } /* CSS switches HERE */
        100% { transform: translateX(100%); opacity: 0; }
      }

      /* Fast blur - CSS switches at peak blur (150ms) */
      .css-transition-overlay.blur {
        background: rgba(52, 38, 30, 0.8);
        backdrop-filter: blur(0px);
        animation: blurTransition 0.3s ease-out forwards;
      }

      @keyframes blurTransition {
        0% { backdrop-filter: blur(0px); opacity: 0; }
        50% { backdrop-filter: blur(20px); opacity: 1; } /* CSS switches HERE */
        100% { backdrop-filter: blur(0px); opacity: 0; }
      }

      /* Fast glitch - CSS switches during glitch (100ms) */
      .css-transition-overlay.glitch {
        background: #000;
        animation: glitchTransition 0.2s ease-out forwards;
      }

      @keyframes glitchTransition {
        0% { opacity: 0; }
        25% { opacity: 1; transform: translateX(-2px); }
        50% { transform: translateX(2px); } /* CSS switches HERE */
        75% { transform: translateX(-1px); }
        100% { opacity: 0; transform: translateX(0); }
      }

      /* Matrix-style transition - CSS switches at 50% (350ms) */
      .css-transition-overlay.matrix {
        background: #000;
        opacity: 1;
        animation: matrixTransition 0.7s ease-out forwards;
      }

      .matrix::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: repeating-linear-gradient(
          0deg,
          transparent,
          transparent 2px,
          #00ff00 2px,
          #00ff00 4px
        );
        animation: matrixScroll 0.3s linear infinite;
      }

      @keyframes matrixScroll {
        0% { transform: translateY(-100%); }
        100% { transform: translateY(0); }
      }

      @keyframes matrixTransition {
        0% { opacity: 1; }
        50% { opacity: 1; } /* CSS switches HERE */
        100% { opacity: 0; }
      }

      /* Body transition states */
      body.transitioning {
        overflow: hidden;
      }

      body.clay-mode {
        transition: background-color 0.3s ease;
      }

      body.signup-mode {
        transition: background-color 0.3s ease;
        background-color: #fef6ef;
      }
    `;
    document.head.appendChild(style);
  }

  // Utility function
  wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Brown blob wipe animation
  async createWipeAnimation() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    console.log('🟤 Creating brown blob animation...');

    // Add transitioning class to body
    document.body.classList.add('transitioning');

    // Create brown blob overlay
    const overlay = document.createElement('div');
    overlay.className = 'css-transition-overlay wipe';
    document.body.appendChild(overlay);

    // Trigger animation
    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
    });

    // SWITCH CSS AT THE PEAK OF ANIMATION (50% point = 400ms)
    setTimeout(() => {
      console.log('🔄 Switching CSS at animation peak...');
      this.disableAllClayStyles();
      document.body.className = 'signup-mode transitioning'; // Keep transitioning class
      document.documentElement.setAttribute('data-mode', 'signup');
    }, 400); // Switch exactly when blob is fully expanded

    // Wait for animation to complete
    await this.wait(800);

    // Clean up
    overlay.remove();
    document.body.classList.remove('transitioning');
    this.isTransitioning = false;
    
    console.log('✅ Brown blob animation complete');
  }

  // Fast slide animation
  async createSlideAnimation() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    console.log('🎬 Creating slide animation...');
    document.body.classList.add('transitioning');

    const overlay = document.createElement('div');
    overlay.className = 'css-transition-overlay slide';
    document.body.appendChild(overlay);
    
    requestAnimationFrame(() => overlay.style.opacity = '1');

    // Switch CSS at 50% of 400ms = 200ms
    setTimeout(() => {
      this.disableAllClayStyles();
      document.body.className = 'signup-mode transitioning';
      document.documentElement.setAttribute('data-mode', 'signup');
    }, 200);

    await this.wait(400);
    overlay.remove();
    document.body.classList.remove('transitioning');
    this.isTransitioning = false;
    console.log('✅ Slide animation complete');
  }

  // Fast blur animation
  async createBlurAnimation() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    console.log('🌫️ Creating blur animation...');
    document.body.classList.add('transitioning');

    const overlay = document.createElement('div');
    overlay.className = 'css-transition-overlay blur';
    document.body.appendChild(overlay);
    
    requestAnimationFrame(() => overlay.style.opacity = '1');

    // Switch CSS at peak blur = 150ms
    setTimeout(() => {
      this.disableAllClayStyles();
      document.body.className = 'signup-mode transitioning';
      document.documentElement.setAttribute('data-mode', 'signup');
    }, 150);

    await this.wait(300);
    overlay.remove();
    document.body.classList.remove('transitioning');
    this.isTransitioning = false;
    console.log('✅ Blur animation complete');
  }

  // Fast glitch animation
  async createGlitchAnimation() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    console.log('⚡ Creating glitch animation...');
    document.body.classList.add('transitioning');

    const overlay = document.createElement('div');
    overlay.className = 'css-transition-overlay glitch';
    document.body.appendChild(overlay);
    
    requestAnimationFrame(() => overlay.style.opacity = '1');

    // Switch CSS during glitch = 100ms
    setTimeout(() => {
      this.disableAllClayStyles();
      document.body.className = 'signup-mode transitioning';
      document.documentElement.setAttribute('data-mode', 'signup');
    }, 100);

    await this.wait(200);
    overlay.remove();
    document.body.classList.remove('transitioning');
    this.isTransitioning = false;
    console.log('✅ Glitch animation complete');
  }

  // Matrix animation
  async createMatrixAnimation() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    console.log('🔢 Creating matrix animation...');
    document.body.classList.add('transitioning');

    const overlay = document.createElement('div');
    overlay.className = 'css-transition-overlay matrix';
    document.body.appendChild(overlay);
    
    requestAnimationFrame(() => overlay.style.opacity = '1');

    // Switch CSS at 50% of 700ms = 350ms
    setTimeout(() => {
      this.disableAllClayStyles();
      document.body.className = 'signup-mode transitioning';
      document.documentElement.setAttribute('data-mode', 'signup');
    }, 350);

    await this.wait(700);
    overlay.remove();
    document.body.classList.remove('transitioning');
    this.isTransitioning = false;
    console.log('✅ Matrix animation complete');
  }

  checkAndDisableClayCSS() {
    const currentPath = window.location.pathname;
    const signupPaths = ['/signup', '/pending-approval'];
    const shouldDisableClay = signupPaths.some(path => currentPath.startsWith(path));
    
    if (shouldDisableClay) {
      console.log('🚫 PREEMPTIVELY disabling Clay CSS');
      this.disableAllClayStyles();
      // Don't override the classes that were already set by the IIFE
      if (!document.body.className.includes('signup-mode')) {
        document.body.className = 'signup-mode';
      }
      if (!document.documentElement.className.includes('signup-mode')) {
        document.documentElement.className = 'signup-mode';
      }
      document.documentElement.setAttribute('data-mode', 'signup');
    }
  }

  disableAllClayStyles() {
    const clayPatterns = [
      'fs-clay', 'clay-landing-wrapper', '--fonts--body-font',
      'var(--_swatches', '/clay', 'clay_bundle', 'style.css',
      'global.css', 'navigation.css', 'HeroSection.css', 'SocialProofSection.css',
      'SecondaryNavigation.css', 'LegalEfficiencySection.css', 'RotatingPrismSection.css',
      'pricing_cards_section.css', 'feature_comparison_section.css', 'faq_section.css',
      'testimonials.css', 'FlexibleWorkflowsSection.css'
    ];

    const allStyles = document.querySelectorAll('style, link[rel="stylesheet"]');
    let disabledCount = 0;
    
    allStyles.forEach(style => {
      const content = style.textContent || style.href || '';
      const isClayStyle = clayPatterns.some(pattern => content.includes(pattern));
      
      if (isClayStyle) {
        style.disabled = true;
        style.setAttribute('data-clay-disabled', 'true');
        style.setAttribute('data-disabled-reason', 'preload-manager');
        disabledCount++;
      }
    });
    
    console.log(`✅ Disabled ${disabledCount} Clay styles`);
  }

  watchForNewStyles() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === 'STYLE' || (node.tagName === 'LINK' && node.rel === 'stylesheet')) {
            const currentPath = window.location.pathname;
            const signupPaths = ['/signup', '/pending-approval'];
            const shouldDisableClay = signupPaths.some(path => currentPath.startsWith(path));
            
            if (shouldDisableClay) {
              const content = node.textContent || node.href || '';
              const clayPatterns = [
                'fs-clay', 'clay-landing-wrapper', '--fonts--body-font', 
                'var(--_swatches', '/clay', 'clay_bundle'
              ];
              
              if (clayPatterns.some(pattern => content.includes(pattern))) {
                node.disabled = true;
                node.setAttribute('data-clay-disabled', 'true');
                node.setAttribute('data-disabled-reason', 'mutation-observer');
                console.log('🚫 Instantly blocked new Clay style');
              }
            }
          }
        });
      });
    });

    observer.observe(document.head, { childList: true, subtree: true });
    window.__clayPreloadObserver = observer;
  }

  // Public methods for different animation types
  async disableClayStyles(animationType = 'wipe') {
    switch (animationType) {
      case 'slide':
        await this.createSlideAnimation();
        break;
      case 'blur':
        await this.createBlurAnimation();
        break;
      case 'glitch':
        await this.createGlitchAnimation();
        break;
      case 'matrix':
        await this.createMatrixAnimation();
        break;
      case 'wipe':
      default:
        await this.createWipeAnimation();
        break;
    }
    console.log(`🎯 Clay styles disabled with ${animationType} animation`);
  }

  // Instant enable (no animation for going back to landing)
  enableClayStyles() {
    const disabledStyles = document.querySelectorAll('[data-clay-disabled="true"]');
    disabledStyles.forEach(style => {
      style.disabled = false;
      style.removeAttribute('data-clay-disabled');
      style.removeAttribute('data-disabled-reason');
    });
    
    document.body.className = 'clay-mode';
    document.documentElement.className = 'clay-mode';
    document.documentElement.setAttribute('data-mode', 'clay');
    console.log('✅ Clay styles enabled instantly');
  }
}

// Create global instance
window.__clayPreloadManager = new PreloadCSSManager();
export default window.__clayPreloadManager;